import {JQueryStatic} from 'jquery';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {GlobalService} from '../../service/global.service';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {TipoPeriodicidade} from '../../model/constantes';
import {ModalService} from '../../service/modal.service';
import {FtaService} from '../../service/fta.service';
import {UtilApi} from '../../service/api/util.api';
import {ConstantesApiService} from '../../service/api/constantes.api';
import {CatalogoApiService} from '../../service/api/catalogo.api';
import {DetalhamentoApiService} from '../../service/api/detalhamento.api';
import {PesquisasFiltroApiService} from '../../service/api/pesquisas-filtro.api';
import {
    Cliente,
    InstalacaoProduto,
    Servico,
    Evento,
    EventoTransmissao,
    OrigemTransmissao,
    DestinoTransmissao,
    Parametro,
    ParametroConteudo,
    ItemConfiguracao,
    Operacao,
    UserAplicacao,
    EventoOperacao,
    Dependencia,
    SubfluxoPossivel
} from '../../model/catalogo';
import {userAutorizador} from '../../model/usuario';
import {THIS_EXPR} from '../../../node_modules/@angular/compiler/src/output/output_ast';

declare var $: JQueryStatic;

@Component({
    selector: 'fluxo-cliente-externo',
    templateUrl: './fluxo-cliente-externo.html',
    styleUrls: ['./fluxo-cliente-externo.css']
})

export class FluxoClienteExternoComponent implements OnInit {

    constructor(public globalService: GlobalService, private constantesService: ConstantesApiService, private modalService: ModalService,
                private ftaService: FtaService, public pesquisaService: PesquisasFiltroApiService, public detalhamentoService: DetalhamentoApiService,
                private utilApi: UtilApi, private catalogoApi: CatalogoApiService, private router: Router, private formBuilder: FormBuilder) {
    }

    paginaAtual = 'principal';
    numPagina = 1;
    totalPaginas = 3;
    numRunTask = 1;
    numEvento = 1;
    numEtapa = 1;

    montaArqDestino: string = '';
    montaArqDestinoRetorno: string = '';

    periodicidades: Array<TipoPeriodicidade> = new Array<TipoPeriodicidade>();
    canaisTransmissao: Array<ItemConfiguracao> = new Array<ItemConfiguracao>();
    clientesMF: Array<Cliente> = new Array<Cliente>();
    InstalacoesMF: Array<InstalacaoProduto> = new Array<InstalacaoProduto>();

    clienteOrigem: Cliente = null;
    clienteDestino: Cliente = null;
    clienteRetorno: Cliente = null;
    instalacaoOrigem: InstalacaoProduto = null;
    instalacaoDestino: InstalacaoProduto = null;
    instalacaoRetorno: InstalacaoProduto = null;
    servicosVinculados: Array<Servico> = new Array<Servico>();
    operacaoConversaoLayout: Operacao = null;
    listaMapas: Array<string> = new Array<string>();
    novoMapa: string = '';
    novoMapaR: string = '';

    nome = new FormControl('', [Validators.required]);
    descricao = new FormControl('', [Validators.required]);
    codTipoPeriodicidade = new FormControl('1', []);
    servicos = new FormControl({value: '', disabled: true}, Validators.required);

    /* Origem */
    canalTransmissao = new FormControl('0', []);
    arqOrigem = new FormControl('', [Validators.required]);
    hostnameOrigem = new FormControl('', []);
    uorOrigem = new FormControl('', []);
    clienteOrigemForm = new FormControl('', []);
    convenio = new FormControl('0', []);
    nodeConnect = new FormControl('', []);
    stationRVS = new FormControl('', []);
    siteXFB = new FormControl('', []);
    tpArqOrigem = new FormControl('TEXT', []);
    tratamento = new FormControl('false', []);

    /* Operações */
    descriptografar = new FormControl(false, []);
    descompactar = new FormControl(false, []);
    layout = new FormControl(false, []);
    compactar = new FormControl(false, []);
    tipoArqCompactado = new FormControl('ZIP', []);
    tipoArqCompactado2 = new FormControl('ZIP', []);
    tpLayout = new FormControl('', []);
    inserirHeader = new FormControl('', []);
    conteudoHeader = new FormControl('', []);
    conteudoTrailer = new FormControl('', []);
    criptografar = new FormControl(false, []);

    /* Destino */
    tipoDestino = new FormControl('0', [Validators.required]);
    dirDestino = new FormControl('', []);
    arqDestino = new FormControl('', [Validators.required]);
    usarNmArqOrigem = new FormControl('true', []);
    usarArqOrigem = new FormControl('false', []);
    ambienteMFDestino = new FormControl('0', []);
    hostnameDestino = new FormControl('', []);
    uorDestino = new FormControl('', []);
    arqExistente = new FormControl('RPL', []);
    recfm = new FormControl('FB', []);
    lrecl = new FormControl('', []);
    blksize = new FormControl('', []);
    rotinaDestino = new FormControl('', []);
    temArqRetorno = new FormControl('false', []);

    /* Retorno */
    ambienteMFRetorno = new FormControl('0', []);
    arqOrigemRetorno = new FormControl('', []);
    arqDestinoRetorno = new FormControl('', []);
    usarNmArqOrigemR = new FormControl('true', []);
    usarArqOrigemR = new FormControl('false', []);
    tratamentoRetorno = new FormControl('false', []);
    descriptografarR = new FormControl(false, []);
    descompactarR = new FormControl(false, []);
    layoutR = new FormControl(false, []);
    compactarR = new FormControl(false, []);
    tipoArqCompactadoR = new FormControl('ZIP', []);
    tipoArqCompactadoR2 = new FormControl('ZIP', []);
    tpLayoutR = new FormControl('', []);
    inserirHeaderR = new FormControl('', []);
    conteudoHeaderR = new FormControl('', []);
    conteudoTrailerR = new FormControl('', []);
    criptografarR = new FormControl(false, []);

    fluxoForm: FormGroup = this.formBuilder.group({
        nome: this.nome,
        descricao: this.descricao,
        codTipoPeriodicidade: this.codTipoPeriodicidade,
        servicos: this.servicos,

        /* Origem */
        canalTransmissao: this.canalTransmissao,
        arqOrigem: this.arqOrigem,
        hostnameOrigem: this.hostnameOrigem,
        uorOrigem: this.uorOrigem,
        clienteOrigemForm: this.clienteOrigemForm,
        convenio: this.convenio,
        nodeConnect: this.nodeConnect,
        stationRVS: this.stationRVS,
        siteXFB: this.siteXFB,
        tpArqOrigem: this.tpArqOrigem,

        /* Operações */
        descriptografar: this.descriptografar,
        descompactar: this.descompactar,
        layout: this.layout,
        tpLayout: this.tpLayout,
        compactar: this.compactar,
        tipoArqCompactado: this.tipoArqCompactado,
        tipoArqCompactado2: this.tipoArqCompactado2,
        inserirHeader: this.inserirHeader,
        conteudoHeader: this.conteudoHeader,
        conteudoTrailer: this.conteudoTrailer,
        criptografar: this.criptografar,

        /* Destino */
        tipoDestino: this.tipoDestino,
        dirDestino: this.dirDestino,
        arqDestino: this.arqDestino,
        ambienteMFDestino: this.ambienteMFDestino,
        hostnameDestino: this.hostnameDestino,
        uorDestino: this.uorDestino,
        arqExistente: this.arqExistente,
        recfm: this.recfm,
        lrecl: this.lrecl,
        blksize: this.blksize,
        rotinaDestino: this.rotinaDestino,
        temArqRetorno: this.temArqRetorno,

        /* Retorno */
        ambienteMFRetorno: this.ambienteMFRetorno,
        arqOrigemRetorno: this.arqOrigemRetorno,
        arqDestinoRetorno: this.arqDestinoRetorno,
        descriptografarR: this.descriptografarR,
        descompactarR: this.descompactarR,
        layoutR: this.layoutR,
        tpLayoutR: this.tpLayoutR,
        compactarR: this.compactarR,
        tipoArqCompactadoR: this.tipoArqCompactadoR,
        tipoArqCompactado2R: this.tipoArqCompactadoR2,
        inserirHeaderR: this.inserirHeaderR,
        conteudoHeaderR: this.conteudoHeaderR,
        conteudoTrailerR: this.conteudoTrailerR,
        criptografarR: this.criptografarR,

    });

    tooltips: Array<string> = [];

    ngOnInit() {
        this.globalService.loading = true;
        this.utilApi.invocacaoRemotaComRetry(5, 1000, this, FluxoClienteExternoComponent.prototype.carregarConstantes);
        this.utilApi.invocacaoRemotaComRetry(5, 1000, this, FluxoClienteExternoComponent.prototype.carregarCanaisDeTransmissao);
        this.utilApi.invocacaoRemotaComRetry(5, 1000, this, FluxoClienteExternoComponent.prototype.carregarOperacaoLayout);
        this.globalService.loading = false;
        this.montaArqDestino = '';
    }

    carregarConstantes() {
        this.globalService.loading = true;
        this.constantesService.buscaTipoPeriodicidade(0)
            .subscribe(periodicidades => {
                this.periodicidades = periodicidades as Array<TipoPeriodicidade>;
                this.globalService.loading = false;
            });
    }

    carregarCanaisDeTransmissao() {
        this.globalService.loading = true;
        let filtros: Array<any> = new Array<any>();

        filtros.push({'filtroItemConfiguracao': {'tipoItemConfiguracao': '1'}});
        this.pesquisaService.filtraItemConfiguracao(filtros)
            .subscribe(
                listaIC => {
                    let resultado = listaIC as Array<ItemConfiguracao>;
                    if (resultado.length > 0) {
                        this.canaisTransmissao = resultado;
                    }
                    this.globalService.loading = false;
                },
                erro => {
                    if (erro.status == 404) {
                    }
                    this.globalService.loading = false;
                }
            );
    }

    // Busca informações sobre a operação de conversão de layout
    carregarOperacaoLayout() {
        this.globalService.loading = true;
        this.detalhamentoService.detalhaOperacao(this.globalService.getConfiguracao().codOperacaoConverteLayout, 0)
            .subscribe(
                operacao => {
                    this.operacaoConversaoLayout = operacao as Operacao;
                    operacao.parmEntrada.forEach(op => {
                        if (op.nome == 'mapaConversao') {
                            this.listaMapas = op.conteudoPadrao;
                        }
                    });
                    this.globalService.loading = false;
                },
                erro => {
                    if (erro.status == 404) {
                    }
                    this.globalService.loading = false;
                }
            );
    }

    // Verificar se layout selecionado = "Outros"
    verificarMapa(local: string) {
        let valor = '';
        if (local == 'R') {
            valor = $('select[id=mapaConversaoR]').val();
        } else {
            valor = $('select[id=mapaConversao]').val();
        }

        if (valor == '999') {
            this.modalService.abrirPaginaModal('mapa-layout-modal', {}, {'mapas': this.listaMapas}, 'Mapa de Conversão', 'Fechar')
                .subscribe(resp => {
                    if (resp != '') {
                        if (local == 'R') {
                            this.novoMapaR = resp;
                            $('#novo-mapa-conversaoR').show();
                        } else {
                            this.novoMapa = resp;
                            $('#novo-mapa-conversao').show();
                        }
                    } else {
                        if (local == 'R') {
                            this.novoMapaR = '';
                            $('#novo-mapa-conversaoR').hide();
                        } else {
                            this.novoMapa = '';
                            $('#novo-mapa-conversao').hide();
                        }
                    }
                });
        } else {
            if (local = 'R') {
                this.novoMapaR = '';
                $('#novo-mapa-conversaoR').hide();
            } else {
                this.novoMapa = '';
                $('#novo-mapa-conversao').hide();
            }
        }
    }

    recuperaDadosMF(local) {

        let ambiente = '';
        let codUserApl = 0;
        let codInstalacao = 0;

        if (local == 'origem') {
            ambiente = this.fluxoForm.value.ambienteMFOrigem;
        } else if (local == 'destino') {
            ambiente = this.fluxoForm.value.ambienteMFDestino;
        } else {
            ambiente = this.fluxoForm.value.ambienteMFRetorno;
        }

        switch (ambiente) {
            case 'desenv':
                codUserApl = this.globalService.getConfiguracao().codClienteMF_desenv;
                codInstalacao = this.globalService.getConfiguracao().codInstalacaoMF_desenv;
                break;
            case 'homologa':
                codUserApl = this.globalService.getConfiguracao().codClienteMF_homologa;
                codInstalacao = this.globalService.getConfiguracao().codInstalacaoMF_homologa;
                break;
            case 'br':
                codUserApl = this.globalService.getConfiguracao().codClienteMF_br;
                codInstalacao = this.globalService.getConfiguracao().codInstalacaoMF_br;
                break;
            case 'b2':
                codUserApl = this.globalService.getConfiguracao().codClienteMF_b2;
                codInstalacao = this.globalService.getConfiguracao().codInstalacaoMF_b2;
                break;
        }

        let clienteMF = new Cliente();
        clienteMF.codTipoCliente = 1;
        clienteMF.userAplicacao = new UserAplicacao();
        clienteMF.userAplicacao.codUserAplicacao = codUserApl;
        clienteMF.userAplicacao.versaoUserAplicacao = 1;

        let instalacaoMF: InstalacaoProduto = new InstalacaoProduto();
        instalacaoMF.codigo = codInstalacao;
        instalacaoMF.versao = 1;

        if (local == 'origem') {
            this.clienteOrigem = clienteMF;
            this.instalacaoOrigem = instalacaoMF;
        } else if (local == 'destino') {
            this.clienteDestino = clienteMF;
            this.instalacaoDestino = instalacaoMF;
        } else {
            this.clienteRetorno = clienteMF;
            this.instalacaoRetorno = instalacaoMF;
        }

    }

    verificaTotalPaginas() {
        this.totalPaginas = 3;
        if (this.tratamento.value == 'true') {
            this.totalPaginas++;
        }
        if (this.temArqRetorno.value == 'true') {
            this.totalPaginas++;
        }
        if (this.tratamentoRetorno.value == 'true') {
            this.totalPaginas++;
        }
    }

    mudaPagina(direcao) {
        if (direcao == 'avancar') {
            this.numPagina++;
            if (this.paginaAtual == 'principal') {
                this.paginaAtual = 'origem';
            } else if (this.paginaAtual == 'origem') {
                if (this.tratamento.value == 'true') {
                    this.paginaAtual = 'operacao';
                } else {
                    this.paginaAtual = 'destino';
                }
            } else if (this.paginaAtual == 'operacao') {
                this.paginaAtual = 'destino';
            } else if (this.paginaAtual == 'destino') {
                this.paginaAtual = 'retorno';
            } else if (this.paginaAtual == 'retorno') {
                this.paginaAtual = 'opretorno';
            }
        } else {
            this.numPagina--;
            if (this.paginaAtual == 'opretorno') {
                this.paginaAtual = 'retorno';
            } else if (this.paginaAtual == 'retorno') {
                this.paginaAtual = 'destino';
            } else if (this.paginaAtual == 'destino') {
                if (this.tratamento.value == 'true') {
                    this.paginaAtual = 'operacao';
                } else {
                    this.paginaAtual = 'origem';
                }
            } else if (this.paginaAtual == 'operacao') {
                this.paginaAtual = 'origem';
            } else {
                this.paginaAtual = 'principal';
            }
        }
    }

    limparCamposOrigem() {
        this.tpArqOrigem.setValue('TEXT');
        this.apagarCD();
        this.apagarRVS();
        this.apagarXFB();
        this.apagarClienteForm();
        this.apagarUOR('origem');
        this.montaArqDestino = '';
        this.numRunTask = 1;
        this.tratamento.setValue('false');
        this.limparOperacoes();
        this.verificaTotalPaginas();
    }

    limparCamposDestino() {
        this.ambienteMFDestino.setValue('0');
        this.arqExistente.setValue('RPL');
        this.recfm.setValue('FB');
        this.lrecl.setValue('');
        this.blksize.setValue('');
        this.rotinaDestino.setValue('');
        this.apagarHostname('destino');
        this.apagarUOR('destino');
        this.usarArqOrigem.setValue('false');
        this.usarNmArqOrigem.setValue('true');
        this.usarNomeArquivoOrigem();
        this.montaArqDestino = '';
        this.numRunTask = 1;
        this.temArqRetorno.setValue('false');
    }

    tratamentoArquivo() {
        if (this.tratamento.value != 'true') {
            this.limparOperacoes();
        }
        this.verificaTotalPaginas();
    }

    limparOperacoes() {
        this.compactar.setValue(false);
        this.descompactar.setValue(false);
        this.layout.setValue(false);
        this.inserirHeader.setValue(false);
        this.tipoArqCompactado.setValue('ZIP');
        this.tipoArqCompactado2.setValue('ZIP');
        this.tpLayout.setValue('');
        this.conteudoHeader.setValue('');
        this.conteudoTrailer.setValue('');
        this.verificaTotalPaginas();
    }

    tratamentoArquivoRetorno() {
        if (this.tratamentoRetorno.value != 'true') {
            this.limparOperacoesRetorno();
        }
        this.verificaTotalPaginas();
    }

    arquivoRetorno() {
        if (this.temArqRetorno.value != 'true') {
            this.limparRetorno();
        }
        this.verificaTotalPaginas();
    }

    limparRetorno() {
        this.tratamentoRetorno.setValue('false');
        this.arqOrigemRetorno.setValue('');
        this.arqDestinoRetorno.setValue('');
        this.ambienteMFRetorno.setValue('0');
        this.limparOperacoesRetorno();
        this.verificaTotalPaginas();
    }

    limparOperacoesRetorno() {
        this.compactarR.setValue(false);
        this.descompactarR.setValue(false);
        this.layoutR.setValue(false);
        this.inserirHeaderR.setValue(false);
        this.tipoArqCompactadoR.setValue('ZIP');
        this.tipoArqCompactadoR2.setValue('ZIP');
        this.tpLayoutR.setValue('');
        this.conteudoHeaderR.setValue('');
        this.conteudoTrailerR.setValue('');
        this.verificaTotalPaginas();
    }

    usarNomeArquivoOrigem() {
        if (this.usarNmArqOrigem.value == 'true') {
            this.arqDestino.setValue('&ArquivoOrigem.');
        } else {
            this.arqDestino.setValue('');
        }
    }

    usarNomeArquivoOrigemRetorno() {
        if (this.usarNmArqOrigemR.value == 'true') {
            this.arqDestinoRetorno.setValue('&ArquivoOrigem.');
        } else {
            this.arqDestinoRetorno.setValue('');
        }
    }

    // Substitui as variáveis do nome do arquivo digitado pelo usuário, deixando-as no padrão necessário à criação do FTA
    preparaVariaveisNomeArquivo(arq: string): string {
        arq = arq.replace(/\$C/g, '&ArquivoOrigem')
            .replace(/\]/g, '].')
            .replace(/\$DT_DD/g, '&$DT_DD.')
            .replace(/\$DT_MM/g, '&$DT_MM.')
            .replace(/\$DT_AAAA/g, '&$DT_AAAA.')
            .replace(/\$DT_AA/g, '&$DT_AA.')
            .replace(/\$HR_HH/g, '&$HR_HH.')
            .replace(/\$HR_hh/g, '&$HR_hh.')
            .replace(/\$HR_MM/g, '&$HR_MM.')
            .replace(/\$HR_SS/g, '&$HR_SS.')
            .replace(/\$HR_PR/g, '&$HR_PR.')
            .replace(/\$TIMESTAMP/g, '&$TIMESTAMP.');
        return arq.trim();
    }

    // Substitui as variáveis do nome do arquivo destino para exibição na página
    montarArqDestino() {

        if (this.tipoDestino.value == 'mainframe') {
            this.arqDestino.setValue(this.arqDestino.value.toUpperCase());
        }

        let temp: string = this.arqDestino.value;
        let origem: string = this.arqOrigem.value;

        let now = new Date();

        temp = temp.replace(/\$DT_DD/g, this.addHtml(now.getDate().toString(), 2))
            .replace(/\$DT_MM/g, this.addHtml(now.getMonth().toString(), 2))
            .replace(/\$DT_AAAA/g, this.addHtml(now.getFullYear().toString(), 0))
            .replace(/\$DT_AA/g, this.addHtml(now.getFullYear().toString().substr(2, 2), 2))
            .replace(/\$HR_HH/g, this.addHtml(now.getHours().toString(), 2))
            .replace(/\$HR_hh/g, this.addHtml('hh', 0))
            .replace(/\$HR_MM/g, this.addHtml(now.getMinutes().toString(), 2))
            .replace(/\$HR_SS/g, this.addHtml(now.getSeconds().toString(), 2))
            .replace(/\$HR_PR/g, this.addHtml('AM/PM', 0))
            .replace(/\$TIMESTAMP/g, this.addHtml(now.getTime().toString(), 0));

        if (this.usarArqOrigem.value == 'true' && origem != '') {
            let variaveisOrigem = temp.match(/\$C\[[0-9-]+:[0-9-]+\]/g);
            if (variaveisOrigem != null) {
                variaveisOrigem.forEach(elemento => {
                    let char = elemento.replace('$C[', '').replace(']', '').split(':');
                    if (parseInt(char[1]) > origem.length || parseInt(char[0]) > origem.length) {
                        temp = this.addHtml('Erro: Não é possível substituir a variável ' + elemento + ': caractere final é maior que o tamanho do arquivo', 0);
                    } else {
                        temp = temp.replace(elemento, this.addHtml(origem.substring(parseInt(char[0]) - 1, parseInt(char[1])), 0));
                    }
                });
            }
        }

        this.montaArqDestino = temp;
    }

    montarArqOrigemRetorno() {
        this.arqOrigemRetorno.setValue(this.arqOrigemRetorno.value.toUpperCase());
    }

    // Substitui as variáveis do nome do arquivo destino para exibição na página
    montarArqDestinoRetorno() {

        let temp: string = this.arqDestinoRetorno.value;
        let origem: string = this.arqOrigemRetorno.value;

        let now = new Date();

        temp = temp.replace(/\$DT_DD/g, this.addHtml(now.getDate().toString(), 2))
            .replace(/\$DT_MM/g, this.addHtml(now.getMonth().toString(), 2))
            .replace(/\$DT_AAAA/g, this.addHtml(now.getFullYear().toString(), 0))
            .replace(/\$DT_AA/g, this.addHtml(now.getFullYear().toString().substr(2, 2), 2))
            .replace(/\$HR_HH/g, this.addHtml(now.getHours().toString(), 2))
            .replace(/\$HR_hh/g, this.addHtml('hh', 0))
            .replace(/\$HR_MM/g, this.addHtml(now.getMinutes().toString(), 2))
            .replace(/\$HR_SS/g, this.addHtml(now.getSeconds().toString(), 2))
            .replace(/\$HR_PR/g, this.addHtml('AM/PM', 0))
            .replace(/\$TIMESTAMP/g, this.addHtml(now.getTime().toString(), 0));

        if (this.usarArqOrigemR.value == 'true' && origem != '') {
            let variaveisOrigem = temp.match(/\$C\[[0-9-]+:[0-9-]+\]/g);
            if (variaveisOrigem != null) {
                variaveisOrigem.forEach(elemento => {
                    let char = elemento.replace('$C[', '').replace(']', '').split(':');
                    if (parseInt(char[1]) > origem.length || parseInt(char[0]) > origem.length) {
                        temp = this.addHtml('Erro: Não é possível substituir a variável ' + elemento + ': caractere final é maior que o tamanho do arquivo', 0);
                    } else {
                        temp = temp.replace(elemento, this.addHtml(origem.substring(parseInt(char[0]) - 1, parseInt(char[1])), 0));
                    }
                });
            }
        }

        this.montaArqDestinoRetorno = temp;
    }

    // Transforma o nome do arquivo em regEx
    nomeArqToRegex(str: string) {
        return this.preg_quote(str.trim()).replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
    }

    preg_quote(str: string) {
        return (str + '').replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&');
    }

    // Adiciona tag HTML nas partes do nome do arquivo que foram substituídas para exibição na página
    addHtml(str: string, digitos: number) {
        if (digitos != 0) {
            if (str.length < digitos) {
                str = '00000000000000000' + str;
                str = str.substr(-digitos);
            }
        }
        return '<span class=\'text-success\'><strong>' + str + '</strong></span>';
    }

    // Adiciona uma barra no final dos campos de diretório de acordo com o conteúdo do campo "/" ou "\"
    barraDiretorio() {
        this.dirDestino.setValue(this.dirDestino.value.trim().replace(/\?/g, '').replace(/\*/g, ''));
        if (this.dirDestino.value.indexOf('\\') > -1 && this.dirDestino.value.charAt(this.dirDestino.value.length - 1) != '\\') {
            this.dirDestino.setValue(this.dirDestino.value + '\\');
        } else if (this.dirDestino.value.indexOf('/') > -1 && this.dirDestino.value.charAt(this.dirDestino.value.length - 1) != '/') {
            this.dirDestino.setValue(this.dirDestino.value + '/');
        }
    }

    selecionarClienteForm() {
        let cli = this.clienteOrigemForm.value;
        this.modalService.abrirPaginaModal('cliente-modal', {}, {
            'tipoCliente': 2,
            'campoBusca': cli,
            'selecionaAutomatico': true
        }, 'Selecionar Cliente Origem', 'Fechar')
            .subscribe(cliente => {
                if (cliente != null) {
                    this.clienteOrigem = cliente;
                    this.clienteOrigemForm.setValue(cliente.mci.nomeCliente);
                    this.clienteOrigemForm.disable();

                    if (this.canalTransmissao.value == 'web') {
                        /* TODO - Verificar se o cliente selecionado está vinculado à instalação SIA padrão. Se não tiver, tem que vincular */
                        this.instalacaoOrigem.codigo = this.globalService.getConfiguracao().codInstalacaoSIAPadrao;
                        this.instalacaoOrigem.versao = 1;
                    }
                }
            });
    }

    apagarClienteForm() {
        this.clienteOrigem = null;
        this.clienteOrigemForm.setValue('');
        this.clienteOrigemForm.enable();
    }

    selecionarCD() {
        let endereco = '';
        let porta = '';

        if (this.instalacaoOrigem != null && (this.instalacaoOrigem.codigo == 0 && this.instalacaoOrigem.nomeItemConfiguracaoProduto == 'Connect_Direct')) {
            this.instalacaoOrigem.parmInstalacaoProduto.forEach(element => {
                switch (element.parmNome) {
                    case 'comm_address':
                        endereco = element.parmConteudo[0].conteudo;
                        break;
                    case 'comm_port':
                        porta = element.parmConteudo[0].conteudo;
                        break;
                }
            });
        }

        this.modalService.abrirPaginaModal('instalacao-produto-modal', {}, {
            'campoBusca': this.nodeConnect.value,
            'nomeItemConfiguracao': 'Connect_Direct',
            'codInstalacao': 0,
            'comm_address': endereco,
            'comm_port': porta,
            'selecionaAutomatico': true,
            'cadastraNovaInstalacao': true,
            'cliente': JSON.stringify(this.clienteOrigem)
        }, 'Selecionar Node Connect:Direct', 'Fechar')
            .subscribe(host => {
                if (host != null) {
                    this.instalacaoOrigem = host;
                    this.nodeConnect.setValue(host.nomeInstalacao);
                    this.nodeConnect.disable();
                }
            });
    }

    apagarCD() {
        this.instalacaoOrigem = null;
        this.nodeConnect.setValue('');
        this.nodeConnect.enable();
    }

    selecionarRVS() {
        let endereco = '';
        let porta = '';
        let oid = '';
        let credit = '';

        if (this.instalacaoOrigem != null && (this.instalacaoOrigem.codigo == 0 && this.instalacaoOrigem.nomeItemConfiguracaoProduto == 'Odette')) {
            this.instalacaoOrigem.parmInstalacaoProduto.forEach(element => {
                switch (element.parmNome) {
                    case 'comm_address':
                        endereco = element.parmConteudo[0].conteudo;
                        break;
                    case 'comm_port':
                        porta = element.parmConteudo[0].conteudo;
                        break;
                    case 'oid':
                        oid = element.parmConteudo[0].conteudo;
                        break;
                    case 'credit':
                        credit = element.parmConteudo[0].conteudo;
                        break;
                }
            });
        }

        this.modalService.abrirPaginaModal('instalacao-produto-modal', {}, {
            'campoBusca': this.stationRVS.value,
            'nomeItemConfiguracao': 'Odette',
            'codInstalacao': 0,
            'comm_address': endereco,
            'comm_port': porta,
            'oid': oid,
            'credit': credit,
            'selecionaAutomatico': true,
            'cadastraNovaInstalacao': true,
            'cliente': JSON.stringify(this.clienteOrigem)
        }, 'Selecionar Station Odette/RVS', 'Fechar')
            .subscribe(host => {
                if (host != null) {
                    this.instalacaoOrigem = host;
                    this.stationRVS.setValue(host.nomeInstalacao);
                    this.stationRVS.disable();
                }
            });
    }

    apagarRVS() {
        this.instalacaoOrigem = null;
        this.stationRVS.setValue('');
        this.stationRVS.enable();
    }

    selecionarXFB() {
        let endereco = '';
        let porta = '';

        if (this.instalacaoOrigem != null && (this.instalacaoOrigem.codigo == 0 && this.instalacaoOrigem.nomeItemConfiguracaoProduto == 'PESIT')) {
            this.instalacaoOrigem.parmInstalacaoProduto.forEach(element => {
                switch (element.parmNome) {
                    case 'comm_address':
                        endereco = element.parmConteudo[0].conteudo;
                        break;
                    case 'comm_port':
                        porta = element.parmConteudo[0].conteudo;
                        break;
                }
            });
        }

        this.modalService.abrirPaginaModal('instalacao-produto-modal', {}, {
            'campoBusca': this.siteXFB.value,
            'nomeItemConfiguracao': 'PESIT',
            'codInstalacao': 0,
            'comm_address': endereco,
            'comm_port': porta,
            'selecionaAutomatico': true,
            'cadastraNovaInstalacao': true,
            'cliente': JSON.stringify(this.clienteOrigem)
        }, 'Selecionar Site PESIT/XFB', 'Fechar')
            .subscribe(host => {
                if (host != null) {
                    this.instalacaoOrigem = host;
                    this.siteXFB.setValue(host.nomeInstalacao);
                    this.siteXFB.disable();
                }
            });
    }

    apagarXFB() {
        this.instalacaoOrigem = null;
        this.siteXFB.setValue('');
        this.siteXFB.enable();
    }

    selecionarUORBlur(local: string) {
        if (local == 'origem' && this.uorOrigem.value != '') {
            this.selecionarUOR(local);
        } else if (local == 'destino' && this.uorDestino.value != '') {
            this.selecionarUOR(local);
        }
    }

    selecionarUOR(local: string) {
        let uor = '';
        if (local == 'origem') {
            uor = this.uorOrigem.value.split(' - ')[0];
        } else {
            uor = this.uorDestino.value.split(' - ')[0];
        }

        this.modalService.abrirPaginaModal('cliente-modal', {}, {
            'tipoCliente': '3',
            'campoBusca': uor,
            'selecionaAutomatico': true
        }, 'Selecionar UOR', 'Fechar')
            .subscribe(cliente => {
                if (cliente != null) {

                    this.globalService.loading = true;
                    let filtros: Array<any> = new Array<any>();
                    filtros.push({
                        'filtroInstalacaoProduto': {
                            'nomeItemConfiguracaoProduto': 'SIA',
                            'clienteVinculado': cliente
                        }
                    });

                    this.pesquisaService.filtraInstalacaoProduto(filtros)
                        .subscribe(
                            listaInstalacoes => {
                                this.globalService.loading = false;
                                this.vincularUOR(local, cliente, listaInstalacoes[0]);
                            },
                            erro => {
                                if (erro.status == 404) {
                                    this.catalogoApi.vinculacaoClienteInstalacaoProduto(this.globalService.getConfiguracao().codInstalacaoSIAPadrao, 1, cliente)
                                        .subscribe(
                                            resp => {
                                                let inst = new InstalacaoProduto();
                                                inst.codigo = this.globalService.getConfiguracao().codInstalacaoSIAPadrao;
                                                inst.versao = 0;
                                                this.vincularUOR(local, cliente, inst);
                                            },
                                            error => {
                                                this.modalService.exibirMensagem('Erro', 'Erro ao vincular UOR à instalação SIA Padrão', 'Fechar');
                                            });
                                }
                                this.globalService.loading = false;
                            }
                        );
                }
            });
    }

    vincularUOR(local: string, cliente: Cliente, instalacao: InstalacaoProduto) {
        if (local == 'origem') {
            this.clienteOrigem = cliente;
            this.instalacaoOrigem = instalacao;
            this.uorOrigem.setValue(cliente.uor.codUor + ' - ' + cliente.uor.nomeDependencia);
            this.uorOrigem.disable();
        } else {
            this.clienteDestino = cliente;
            this.instalacaoDestino = instalacao;
            this.uorDestino.setValue(cliente.uor.codUor + ' - ' + cliente.uor.nomeDependencia);
            this.uorDestino.disable();
        }

    }

    apagarUOR(local: string) {
        if (local == 'origem') {
            this.clienteOrigem = null;
            this.uorOrigem.setValue('');
            this.uorOrigem.enable();
        } else {
            this.clienteDestino = null;
            this.uorDestino.setValue('');
            this.uorDestino.enable();
        }
    }

    selecionarHostname(local: string) {
        let hostname = '';
        if (local == 'origem') {
            if ($('#botaoSelecionarHostnameOrigem').prop('disabled') == true) {
                return false;
            }
            hostname = this.hostnameOrigem.value;
        } else {
            if ($('#botaoSelecionarHostnameDestino').prop('disabled') == true) {
                return false;
            }
            hostname = this.hostnameDestino.value;
        }

        this.modalService.abrirPaginaModal('hostname-modal', {}, {
            'campoBusca': hostname,
            'nomeItemConfiguracao': 'Connect_Direct', 'cadastraNovaInstalacao': true
        }, 'Selecionar Hostname', 'Fechar')
            .subscribe(resp => {
                if (resp != null) {

                    let inst = resp.instalacao;
                    let cli = resp.cliente;
                    let hostnames = '';

                    inst.itemConfiguracaoVinculado.forEach(item => {
                        hostnames == '' ? hostnames = item : hostnames = hostnames + ', ' + item;
                    });

                    if (local == 'origem') {
                        this.instalacaoOrigem = inst;
                        this.clienteOrigem = cli;
                        this.hostnameOrigem.setValue(hostnames);
                        this.hostnameOrigem.disable();
                        $('#botaoSelecionarHostnameOrigem').prop('disabled', true);
                    } else {
                        this.instalacaoDestino = inst;
                        this.clienteDestino = cli;
                        this.hostnameDestino.setValue(hostnames);
                        this.hostnameDestino.disable();
                        $('#botaoSelecionarHostnameDestino').prop('disabled', true);
                    }

                }
            });
    }

    apagarHostname(local: string) {
        if (local == 'origem') {
            this.instalacaoOrigem = null;
            this.hostnameOrigem.setValue('');
            this.hostnameOrigem.enable();
            $('#botaoSelecionarHostnameOrigem').prop('disabled', false);
        } else {
            this.instalacaoDestino = null;
            this.hostnameDestino.setValue('');
            this.hostnameDestino.enable();
            $('#botaoSelecionarHostnameDestino').prop('disabled', false);
        }
    }

    selecionarServico() {
        let selecionados = '';

        if (this.servicosVinculados.length > 0) {
            selecionados = JSON.stringify(this.servicosVinculados);
        }

        this.modalService.abrirPaginaModal('servico-modal', {}, {'selecionados': selecionados}, 'Selecionar Serviços', 'Fechar')
            .subscribe(serv => {
                if (serv != null) {
                    this.servicosVinculados = serv;
                    let servs: string = '';
                    serv.forEach(element => {
                        servs = servs + element.nome + '\n';
                    });
                    this.servicos.setValue(servs);
                }
            });
    }

    apagarServico() {
        this.servicosVinculados.length = 0;
        this.servicos.setValue('');
    }

    // Verifica se a instalação de produto já existe ou se deve ser inserida na base de dados
    verificarInstalacaoProduto() {
        // Instalação Origem
        if (this.instalacaoOrigem.codigo == 0) {
            this.catalogoApi.criaEditaInstalacaoProduto(0, 0, this.instalacaoOrigem)
                .subscribe(
                    resp => {
                        this.instalacaoOrigem.codigo = resp.codigoCriado;
                        this.instalacaoOrigem.versao = resp.versaoCriada;
                    },
                    error => {
                        this.modalService.exibirMensagem('Erro', 'Erro ao salvar instalação de origem informado', 'Fechar');
                    });
        }

        // Instalação Destino
        if (this.instalacaoDestino.codigo == 0) {
            this.catalogoApi.criaEditaInstalacaoProduto(0, 0, this.instalacaoDestino)
                .subscribe(
                    resp => {
                        this.instalacaoDestino.codigo = resp.codigoCriado;
                        this.instalacaoDestino.versao = resp.versaoCriada;
                    },
                    error => {
                        this.modalService.exibirMensagem('Erro', 'Erro ao salvar o hostname de destino informado', 'Fechar');
                    });
        }
    }

    // Verifica se o cliente já existe ou se deve ser inserido na base de dados
    verificarCliente() {
        // TODO - Deixar síncrono
        let user: userAutorizador = new userAutorizador();

        // Verifica Cliente Destino
        if (this.clienteDestino.codTipoCliente == 1 && this.clienteDestino.userAplicacao.codUserAplicacao == 0) {
            user.username = this.clienteDestino.userAplicacao.nomeUserAplicacao;
            user.descricao = this.clienteDestino.userAplicacao.descricaoUserAplicacao;
            user.senha = 'connect';

            this.catalogoApi.criaEditaUsuario(0, 0, user)
                .subscribe(
                    resp => {
                        this.clienteDestino.userAplicacao.codUserAplicacao = resp.codigo;
                        this.clienteDestino.userAplicacao.versaoUserAplicacao = resp.versao;

                        // Atualizar a instalação de produto com o cliente criado:
                        // Se codigoInstalaçao == 0, colocar na instalacão que ainda será criada; Se codigoInstalaçao != 0, utilizar a API
                        if (this.instalacaoDestino.codigo == 0) {
                            this.instalacaoDestino.clienteVinculado = new Array<Cliente>();
                            this.instalacaoDestino.clienteVinculado.push(this.clienteDestino);
                        } else {
                            this.catalogoApi.vinculacaoClienteInstalacaoProduto(this.instalacaoDestino.codigo, this.instalacaoDestino.versao, this.clienteDestino)
                                .subscribe(
                                    resp => {
                                    },
                                    error => {
                                        this.modalService.exibirMensagem('Erro', 'Erro ao vincular cliente ao hostname de destino informado', 'Fechar');
                                    });
                        }
                    },
                    error => {
                        this.modalService.exibirMensagem('Erro', 'Erro ao salvar cliente vinculado ao hostname de destino informado', 'Fechar');
                    });
        }
    }

    // Monta runtask no SNODE para executar script/rotina após transferência bem sucedida
    runtaskSnodeAposTransf() {
        let pgm = '';
        let sysopts = '';
        let sOperacional = '';
        if (this.fluxoForm.value.tipoDestino == 'mainframe') {
            sOperacional = 'mainframe';
        } else {
            this.instalacaoDestino.parmInstalacaoProduto.forEach(parm => {
                if (parm.parmNome == 'sistema_operacional') {
                    sOperacional = parm.parmConteudo[0].conteudo;
                }
            });
        }
        if (sOperacional == 'mainframe') {
            pgm = 'DGADTSUB';
            sysopts = 'C\'DSN=DSS.CDTP01.JCL.FILE(GMTECTMR),DISP=SHR\' C\'TABELA ' + this.fluxoForm.value.rotinaDestino.substr(0, 3) +
                '\', C\'SCHEDULE ' + this.fluxoForm.value.rotinaDestino + '\', C\'DT &$DT_DD.&$DT_MM.&$DT_AA.\', C\'FILE ' + this.fluxoForm.value.arqDestino + '\'';
        } else if (sOperacional == 'WINDOWS') {
            pgm = 'WINDOWS';
            sysopts = 'cmd(' + this.fluxoForm.value.rotinaDestino + ')';
        } else {
            pgm = 'UNIX';
            sysopts = this.fluxoForm.value.rotinaDestino;

        }
        return this.montaRuntask('0', '=', 'TASK', 'SNODE', pgm, sysopts);
    }

    // Monta uma nova runtask, calculando o número sequencial -> Run1, Run2, ....
    montaRuntask(rc_cond, simbolo_rc, type, node, pgm, sysopts): Array<Parametro> {
        let parms = new Array<Parametro>();
        if (this.numRunTask == 1) {
            parms.push(this.novoParametro('rc_cond_run', rc_cond));
            parms.push(this.novoParametro('simbolo_rc_cond', simbolo_rc));
        }
        parms.push(this.novoParametro('run' + this.numRunTask + '_type', type));
        parms.push(this.novoParametro('run' + this.numRunTask + '_node', node));
        parms.push(this.novoParametro('run' + this.numRunTask + '_pgm', pgm));
        parms.push(this.novoParametro('run' + this.numRunTask + '_sysopts', sysopts));
        this.numRunTask++;
        return parms;
    }

    // Retorna um novo Parâmetro para os Eventos (transmissão, operação e processamento)
    novoParametro(parmNome: string, conteudo: string): Parametro {
        let parmTransmissao: Parametro = new Parametro();
        let parmConteudo: ParametroConteudo = new ParametroConteudo();
        parmTransmissao.parmConteudo = new Array<ParametroConteudo>();
        parmTransmissao.parmNome = parmNome;
        parmConteudo.nrPosicao = 0;
        parmConteudo.conteudo = conteudo;
        parmTransmissao.parmConteudo.push(parmConteudo);
        return parmTransmissao;
    }

    temOperacao(): Boolean {
        if ($('.checkOperacao:checked').length > 0) {
            return true;
        }
        return false;
    }

    temRetorno(): Boolean {
        if (this.temArqRetorno.value == 'true') {
            return true;
        }
        return false;
    }

    temOperacaoRetorno(): Boolean {
        if ($('.checkOperacaoRetorno:checked').length > 0) {
            return true;
        }
        return false;
    }

    // Função que retorna os eventos de Operação correspondentes às operações selecionadas
    eventosOperacao(): Array<Evento> {

        let eventos = new Array<Evento>();
        let temp = new Array<string>();

        $('.checkOperacao:checked').each(function () {
            temp.push($(this).val());
        });

        temp.forEach(element => {

            // Novo evento
            let evt: Evento = new Evento();
            evt.evento = this.numEvento;
            evt.etapa = this.numEtapa;

            // alterado por Joelson
            // evt.grupo = 1;

            let varGrupo1: Number = 1;
            evt.grupo.push(varGrupo1);


            evt.descricao = 'Operação criada automaticamente através do fluxo simplificado';
            evt.codTipoEvento = 2;
            evt.codTipoTrigger = 4;
            evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

            //alterado por Joelson
            // evt.mensagemParaProtocolo = "Mensagem para protocolo";

            evt.mensagemParaProtocoloEmSucesso = '';
            evt.mensagemParaProtocoloEmErro = '';

            evt.servicosVinculados = this.servicosVinculados;
            evt.subfluxoVinculado = [];
            evt.subfluxoVinculado.push(1);

            evt.dependencia = new Array<Dependencia>();
            let dep = new Dependencia();
            dep.eventoAnterior = this.numEvento - 1;
            dep.codRetornoMin = 0;
            dep.codRetornoMax = 0;

            //alterado por Joelson
            //dep.qtdSegundosMaxEntreEventos = 0;
            evt.qtdSegundosMaxEntreEventos = 0;

            evt.dependencia.push(dep);

            // Novo evento Operação
            let eventoOperacao = new EventoOperacao();

            // Definir parâmetros operação
            eventoOperacao.parmOperacao = new Array<Parametro>();

            switch (element) {
                case 'descompactar':
                    eventoOperacao.codOperacao = this.globalService.getConfiguracao().codOperacaoDescompacta;
                    eventoOperacao.vrsOperacao = 1;
                    eventoOperacao.parmOperacao.push(this.novoParametro('arquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                    eventoOperacao.parmOperacao.push(this.novoParametro('tipo', $('#tipoArqCompactado').val()));
                    break;
                case 'layout':
                    let mapa = this.novoMapa;
                    if (mapa == '') {
                        mapa = $('select[id=mapaConversao]').val();
                    }
                    eventoOperacao.codOperacao = this.globalService.getConfiguracao().codOperacaoConverteLayout;
                    eventoOperacao.vrsOperacao = 1;
                    eventoOperacao.parmOperacao.push(this.novoParametro('arquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                    eventoOperacao.parmOperacao.push(this.novoParametro('mapaConversao', mapa));
                    break;
                case 'compactar':
                    eventoOperacao.codOperacao = this.globalService.getConfiguracao().codOperacaoCompacta;
                    eventoOperacao.vrsOperacao = 1;
                    eventoOperacao.parmOperacao.push(this.novoParametro('arquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                    eventoOperacao.parmOperacao.push(this.novoParametro('tipo', $('#tipoArqCompactado2').val()));
                    break;
                case 'inserirHeader':
                    eventoOperacao.codOperacao = this.globalService.getConfiguracao().codOperacaoInsereHeader;
                    eventoOperacao.vrsOperacao = 1;
                    eventoOperacao.parmOperacao.push(this.novoParametro('arquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                    eventoOperacao.parmOperacao.push(this.novoParametro('conteudoHeader', $('#conteudoHeader').val()));
                    eventoOperacao.parmOperacao.push(this.novoParametro('conteudoTrailer', $('#conteudoTrailer').val()));
                    break;
            }

            evt.detalheEventoOperacao = eventoOperacao;

            this.numEvento++;
            this.numEtapa++;
            eventos.push(evt);
        });
        return eventos;
    }

    // Função que retorna os eventos de Operação correspondentes às operações selecionadas para o arquivo de Retorno
    eventosOperacaoRetorno(): Array<Evento> {

        let eventos = new Array<Evento>();
        let temp = new Array<string>();

        $('.checkOperacaoRetorno:checked').each(function () {
            temp.push($(this).val());
        });

        temp.forEach(element => {

            // Novo evento
            let evt: Evento = new Evento();
            evt.evento = this.numEvento;
            evt.etapa = this.numEtapa;

            // alterado por Joelson
            //  evt.grupo = 2;

            let varGrupo2: Number = 2;
            evt.grupo.push(varGrupo2);


            evt.descricao = 'Operação criada automaticamente através do fluxo simplificado';
            evt.codTipoEvento = 2;
            evt.codTipoTrigger = 4;
            evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

            // alterado por Joelson
            // evt.mensagemParaProtocolo = "Mensagem para protocolo";
            evt.mensagemParaProtocoloEmSucesso = '';
            evt.mensagemParaProtocoloEmErro = '';

            evt.servicosVinculados = this.servicosVinculados;
            evt.subfluxoVinculado = [];
            evt.subfluxoVinculado.push(1);

            evt.dependencia = new Array<Dependencia>();
            let dep = new Dependencia();
            dep.eventoAnterior = this.numEvento - 1;
            dep.codRetornoMin = 0;
            dep.codRetornoMax = 0;

            //alterado por Joelson
            //dep.qtdSegundosMaxEntreEventos = 0;
            evt.qtdSegundosMaxEntreEventos = 0;

            evt.dependencia.push(dep);

            // Novo evento Operação
            let eventoOperacao = new EventoOperacao();

            // Definir parâmetros operação
            eventoOperacao.parmOperacao = new Array<Parametro>();

            switch (element) {
                case 'descompactarR':
                    eventoOperacao.codOperacao = this.globalService.getConfiguracao().codOperacaoDescompacta;
                    eventoOperacao.vrsOperacao = 1;
                    eventoOperacao.parmOperacao.push(this.novoParametro('arquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                    eventoOperacao.parmOperacao.push(this.novoParametro('tipo', $('#tipoArqCompactadoR').val()));
                    break;
                case 'layoutR':
                    let mapa = this.novoMapaR;
                    if (mapa == '') {
                        mapa = $('select[id=mapaConversaoR]').val();
                    }
                    eventoOperacao.codOperacao = this.globalService.getConfiguracao().codOperacaoConverteLayout;
                    eventoOperacao.vrsOperacao = 1;
                    eventoOperacao.parmOperacao.push(this.novoParametro('arquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                    eventoOperacao.parmOperacao.push(this.novoParametro('mapaConversao', mapa));
                    break;
                case 'compactarR':
                    eventoOperacao.codOperacao = this.globalService.getConfiguracao().codOperacaoCompacta;
                    eventoOperacao.vrsOperacao = 1;
                    eventoOperacao.parmOperacao.push(this.novoParametro('arquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                    eventoOperacao.parmOperacao.push(this.novoParametro('tipo', $('#tipoArqCompactadoR2').val()));
                    break;
                case 'inserirHeaderR':
                    eventoOperacao.codOperacao = this.globalService.getConfiguracao().codOperacaoInsereHeader;
                    eventoOperacao.vrsOperacao = 1;
                    eventoOperacao.parmOperacao.push(this.novoParametro('arquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                    eventoOperacao.parmOperacao.push(this.novoParametro('conteudoHeader', $('#conteudoHeaderR').val()));
                    eventoOperacao.parmOperacao.push(this.novoParametro('conteudoTrailer', $('#conteudoTrailerR').val()));
                    break;
            }

            evt.detalheEventoOperacao = eventoOperacao;

            this.numEvento++;
            this.numEtapa++;
            eventos.push(evt);
        });
        return eventos;
    }

    // Primeiro evento de transmissão com origem SIA
    transmissaoSIA1(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEtapa;

        // alterado por Joelson
        // evt.grupo = 1;

        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 2;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        // alterado por Joelson
        //   evt.mensagemParaProtocolo = "Mensagem para protocolo";

        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';


        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'SIA';

        // Dados Origem
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoSIAPadrao;
        origem.vrsInstalacaoProdutoOrigem = 1;
        origem.clienteOrigem = this.clienteOrigem;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();
        destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoSIAPadrao;
        destino.vrsInstalacaoProdutoDestino = 1;

        if (!this.temOperacao() && this.tipoDestino.value == 'web') {
            destino.clienteDestino = this.clienteDestino;
        } else {
            //destino.clienteDestino = this.clienteOrigem;
        }

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemRegex',
            this.nomeArqToRegex(this.fluxoForm.value.arqOrigem)));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino', '&ArquivoOrigem.'));

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        this.numEtapa++;
        return evt;
    }

    // Segundo evento de transmissão com origem SIA
    transmissaoSIA2(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEtapa;

        // alterado por Joelson
        // evt.grupo = 1;

        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);


        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 4;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;


        // alterado por Joelson
        // evt.mensagemParaProtocolo = "Mensagem para protocolo";

        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';


        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        evt.dependencia = new Array<Dependencia>();
        let dep = new Dependencia();
        dep.eventoAnterior = this.numEvento - 1;
        dep.codRetornoMin = 0;
        dep.codRetornoMax = 0;

        // alterado por Joelson
        // dep.qtdSegundosMaxEntreEventos = 0;
        evt.qtdSegundosMaxEntreEventos = 0;

        evt.dependencia.push(dep);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'Connect_Direct';

        // Dados Origem - BB.DSSIA
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoConnectSIA;
        origem.vrsInstalacaoProdutoOrigem = 1;

        let clienteSIA = new Cliente();
        clienteSIA.codTipoCliente = 1;
        clienteSIA.userAplicacao = new UserAplicacao();
        clienteSIA.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteSIA;
        clienteSIA.userAplicacao.versaoUserAplicacao = 1;
        origem.clienteOrigem = clienteSIA;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();

        eventoTransmissao.parmTransmissao = new Array<Parametro>();

        // Se o FTA tem operação, o cliente/instalação destino é o B2B. O cliente destino será informado na última transmissão
        if (this.temOperacao()) {
            let clienteB2B = new Cliente();
            clienteB2B.codTipoCliente = 1;
            clienteB2B.userAplicacao = new UserAplicacao();
            clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
            clienteB2B.userAplicacao.versaoUserAplicacao = 1;

            destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoConnectGMT;
            destino.vrsInstalacaoProdutoDestino = 1;
            destino.clienteDestino = clienteB2B;
            eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino', '/dados/recebidos/&$TIMESTAMP.&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', 'NEW'));
        } else {
            destino.codInstalacaoProdutoDestino = this.instalacaoDestino.codigo;
            destino.vrsInstalacaoProdutoDestino = this.instalacaoDestino.versao;
            destino.clienteDestino = this.clienteDestino;
            eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino',
                this.fluxoForm.value.dirDestino + this.preparaVariaveisNomeArquivo(this.fluxoForm.value.arqDestino)));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', this.fluxoForm.value.arqExistente));

            // Parâmetros específicos do mainframe
            if (this.fluxoForm.value.tipoDestino == 'mainframe') {
                eventoTransmissao.parmTransmissao.push(this.novoParametro('recfm', this.fluxoForm.value.recfm));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('lrecl', this.fluxoForm.value.lrecl));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('blksize', this.fluxoForm.value.blksize));
            }

            // Montar runtask no SNODE para executar script/rotina após transferência bem sucedida
            if (this.fluxoForm.value.rotinaDestino != '') {
                this.runtaskSnodeAposTransf().forEach(element => {
                    eventoTransmissao.parmTransmissao.push(element);
                });
            }

        }

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoGeradoSIAFisico.'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_origem', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_destino', this.fluxoForm.value.tpArqOrigem));

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        this.numEtapa++;
        return evt;

    }

    // Primeiro evento de transmissão com origem Connect_Direct
    transmissaoConnect1(): Evento {
        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEtapa;

        // alterado por Joelson
        // evt.grupo = 1;

        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 2;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        // alterado por Joelson
        //  evt.mensagemParaProtocolo = "Mensagem para protocolo";

        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'Connect_Direct';

        // Dados Origem
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.instalacaoOrigem.codigo;
        origem.vrsInstalacaoProdutoOrigem = this.instalacaoOrigem.versao;
        origem.clienteOrigem = this.clienteOrigem;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino - BB.DSPERIMETRO
        let destino: DestinoTransmissao = new DestinoTransmissao();
        destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoConnectPerimetro;
        destino.vrsInstalacaoProdutoDestino = 1;

        let clientePerimetro = new Cliente();
        clientePerimetro.codTipoCliente = 1;
        clientePerimetro.userAplicacao = new UserAplicacao();
        clientePerimetro.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClientePerimetro;
        clientePerimetro.userAplicacao.versaoUserAplicacao = 1;
        destino.clienteDestino = clientePerimetro;

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemRegex',
            this.nomeArqToRegex(this.fluxoForm.value.arqOrigem)));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestinoRegex', this.nomeArqToRegex(this.fluxoForm.value.arqOrigem)));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_origem', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_destino', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', this.fluxoForm.value.arqExistente));

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        this.numEtapa++;
        return evt;
    }


    // Segundo evento de transmissão com origem Connect_Direct
    transmissaoConnect2(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEtapa;

        // alterado por Joelson
        // evt.grupo = 1;

        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 4;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        // alterado por Joelson
        //  evt.mensagemParaProtocolo = "Mensagem para protocolo";

        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        evt.dependencia = new Array<Dependencia>();
        let dep = new Dependencia();
        dep.eventoAnterior = this.numEvento - 1;
        dep.codRetornoMin = 0;
        dep.codRetornoMax = 0;

        // alterado por Joelson
        // dep.qtdSegundosMaxEntreEventos = 0;
        evt.qtdSegundosMaxEntreEventos = 0;

        evt.dependencia.push(dep);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'Connect_Direct';

        // Dados Origem - BB.DSPERIMETRO
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoConnectPerimetro;
        origem.vrsInstalacaoProdutoOrigem = 1;

        let clientePerimetro = new Cliente();
        clientePerimetro.codTipoCliente = 1;
        clientePerimetro.userAplicacao = new UserAplicacao();
        clientePerimetro.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClientePerimetro;
        clientePerimetro.userAplicacao.versaoUserAplicacao = 1;
        origem.clienteOrigem = clientePerimetro;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();

        eventoTransmissao.parmTransmissao = new Array<Parametro>();

        // Se o FTA tem operação e o cliente/instalação destino é o B2B, este é o evento final.
        if (this.canalTransmissao.value == 'connect' && !this.temOperacao()) {

            destino.codInstalacaoProdutoDestino = this.instalacaoDestino.codigo;
            destino.vrsInstalacaoProdutoDestino = this.instalacaoDestino.versao;
            destino.clienteDestino = this.clienteDestino;
            eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino',
                this.fluxoForm.value.dirDestino + this.preparaVariaveisNomeArquivo(this.fluxoForm.value.arqDestino)));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', this.fluxoForm.value.arqExistente));

            // Parâmetros específicos do mainframe
            if (this.fluxoForm.value.tipoDestino == 'mainframe') {
                eventoTransmissao.parmTransmissao.push(this.novoParametro('recfm', this.fluxoForm.value.recfm));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('lrecl', this.fluxoForm.value.lrecl));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('blksize', this.fluxoForm.value.blksize));
            }

            // Montar runtask no SNODE para executar script/rotina após transferência bem sucedida
            if (this.fluxoForm.value.rotinaDestino != '') {
                this.runtaskSnodeAposTransf().forEach(element => {
                    eventoTransmissao.parmTransmissao.push(element);
                });
            }

        } else {

            let clienteB2B = new Cliente();
            clienteB2B.codTipoCliente = 1;
            clienteB2B.userAplicacao = new UserAplicacao();
            clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
            clienteB2B.userAplicacao.versaoUserAplicacao = 1;

            destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoConnectGMT;
            destino.vrsInstalacaoProdutoDestino = 1;
            destino.clienteDestino = clienteB2B;
            eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino', '/dados/recebidos/&$TIMESTAMP.&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', 'NEW'));

        }

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_origem', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_destino', this.fluxoForm.value.tpArqOrigem));

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        this.numEtapa++;
        return evt;

    }

    // Primeiro evento de transmissão com origem Odette/RVS
    transmissaoOdettePesit1(): Evento {
        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEtapa;

        // alterado por Joelson
        // evt.grupo = 1;

        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 2;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        // alterado por Joelson
        //  evt.mensagemParaProtocolo = "Mensagem para protocolo";

        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';


        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();

        // Dados Origem
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.instalacaoOrigem.codigo;
        origem.vrsInstalacaoProdutoOrigem = this.instalacaoOrigem.versao;
        origem.clienteOrigem = this.clienteOrigem;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();
        destino.vrsInstalacaoProdutoDestino = 1;

        let clienteB2B = new Cliente();
        clienteB2B.codTipoCliente = 1;
        clienteB2B.userAplicacao = new UserAplicacao();
        clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
        clienteB2B.userAplicacao.versaoUserAplicacao = 1;
        destino.clienteDestino = clienteB2B;

        if (this.canalTransmissao.value == 'xfb') {
            // PESIT -> BBPESITBORDA
            eventoTransmissao.nomeItemConfiguracaoProduto = 'PESIT';
            destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoPESIT;
        } else {
            // Odette -> BBODETTEBORDA
            eventoTransmissao.nomeItemConfiguracaoProduto = 'Odette';
            destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoOdette;
        }

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemRegex',
            this.nomeArqToRegex(this.fluxoForm.value.arqOrigem)));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestinoRegex', this.nomeArqToRegex(this.fluxoForm.value.arqOrigem)));

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        this.numEtapa++;
        return evt;
    }

    // Segundo evento de transmissão com origem Odette/RVS
    transmissaoOdettePesit2(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEtapa;

        // alterado por Joelson
        // evt.grupo = 1;

        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 4;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        // alterado por Joelson
        //evt.mensagemParaProtocolo = "Mensagem para protocolo";
        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        evt.dependencia = new Array<Dependencia>();
        let dep = new Dependencia();
        dep.eventoAnterior = this.numEvento - 1;
        dep.codRetornoMin = 0;
        dep.codRetornoMax = 0;

        // alterado por Joelson
        // dep.qtdSegundosMaxEntreEventos = 0;
        evt.qtdSegundosMaxEntreEventos = 0;

        evt.dependencia.push(dep);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'Odette';

        // Dados Origem - BB.DSPERIMETRO
        let origem: OrigemTransmissao = new OrigemTransmissao();

        let clienteB2B = new Cliente();
        clienteB2B.codTipoCliente = 1;
        clienteB2B.userAplicacao = new UserAplicacao();
        clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
        clienteB2B.userAplicacao.versaoUserAplicacao = 1;
        origem.clienteOrigem = clienteB2B;

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();

        eventoTransmissao.parmTransmissao = new Array<Parametro>();

        if (this.canalTransmissao.value == 'connect') { // Transmissão via Connect

            origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoConnectGMT;
            origem.vrsInstalacaoProdutoOrigem = 1;

            destino.codInstalacaoProdutoDestino = this.instalacaoDestino.codigo;
            destino.vrsInstalacaoProdutoDestino = this.instalacaoDestino.versao;
            destino.clienteDestino = this.clienteDestino;
            eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino',
                this.fluxoForm.value.dirDestino + this.preparaVariaveisNomeArquivo(this.fluxoForm.value.arqDestino)));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', this.fluxoForm.value.arqExistente));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_origem', this.fluxoForm.value.tpArqOrigem));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_destino', this.fluxoForm.value.tpArqOrigem));

            // Parâmetros específicos do mainframe
            if (this.fluxoForm.value.tipoDestino == 'mainframe') {
                eventoTransmissao.parmTransmissao.push(this.novoParametro('recfm', this.fluxoForm.value.recfm));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('lrecl', this.fluxoForm.value.lrecl));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('blksize', this.fluxoForm.value.blksize));
            }

            // Montar runtask no SNODE para executar script/rotina após transferência bem sucedida
            if (this.fluxoForm.value.rotinaDestino != '') {
                this.runtaskSnodeAposTransf().forEach(element => {
                    eventoTransmissao.parmTransmissao.push(element);
                });
            }

        } else { // Transmissão via SIA

            origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoSIAPadrao;
            origem.vrsInstalacaoProdutoOrigem = 1;

            destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoSIAPadrao;
            destino.vrsInstalacaoProdutoDestino = 1;
            destino.clienteDestino = this.clienteDestino;
            eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemB2B', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino', '&ArquivoOrigem.'));

        }

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        this.numEtapa++;
        return evt;

    }

    // Último evento de transmissão com destino Web
    eventoFinalWeb(): Evento {
        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEtapa;

        // alterado por Joelson
        // evt.grupo = 1;

        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 2;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        // alterado por Joelson
        //evt.mensagemParaProtocolo = "Mensagem para protocolo";
        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'SIA';

        let clienteB2B = new Cliente();
        clienteB2B.codTipoCliente = 1;
        clienteB2B.userAplicacao = new UserAplicacao();
        clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
        clienteB2B.userAplicacao.versaoUserAplicacao = 1;

        // Dados Origem
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoSIAPadrao;
        origem.vrsInstalacaoProdutoOrigem = 1;
        origem.clienteOrigem = clienteB2B;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();
        destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoSIAPadrao;
        destino.vrsInstalacaoProdutoDestino = 1;
        destino.clienteDestino = this.clienteDestino;

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemB2B ', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino', '&ArquivoOrigem.'));

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        this.numEtapa++;
        return evt;
    }

    // Último evento de transmissão com destino BB
    eventoFinalBB(): Evento {
        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEtapa;

        // alterado por Joelson
        // evt.grupo = 1;

        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);


        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 2;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        // alterado por Joelson
        // evt.mensagemParaProtocolo = "Mensagem para protocolo";

        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'Connect_Direct';

        // Dados Origem
        let origem: OrigemTransmissao = new OrigemTransmissao();

        let clienteB2B = new Cliente();
        clienteB2B.codTipoCliente = 1;
        clienteB2B.userAplicacao = new UserAplicacao();
        clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
        clienteB2B.userAplicacao.versaoUserAplicacao = 1;

        origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoConnectGMT;
        origem.vrsInstalacaoProdutoOrigem = 1;
        origem.clienteOrigem = clienteB2B;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();
        destino.codInstalacaoProdutoDestino = this.instalacaoDestino.codigo;
        destino.vrsInstalacaoProdutoDestino = this.instalacaoDestino.versao;
        destino.clienteDestino = this.clienteDestino;

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigem ', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino',
            this.fluxoForm.value.dirDestino + this.preparaVariaveisNomeArquivo(this.fluxoForm.value.arqDestino)));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_origem', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_destino', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', this.fluxoForm.value.arqExistente));

        // Parâmetros específicos do mainframe
        if (this.fluxoForm.value.tipoDestino == 'mainframe') {
            eventoTransmissao.parmTransmissao.push(this.novoParametro('recfm', this.fluxoForm.value.recfm));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('lrecl', this.fluxoForm.value.lrecl));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('blksize', this.fluxoForm.value.blksize));
        }

        // Montar runtask no SNODE para executar script/rotina após transferência bem sucedida
        if (this.fluxoForm.value.rotinaDestino != '') {
            this.runtaskSnodeAposTransf().forEach(element => {
                eventoTransmissao.parmTransmissao.push(element);
            });
        }

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        this.numEtapa++;
        return evt;
    }

    // Primeiro evento do arquivo de Retorno
    eventoRetorno1(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEtapa;

        // alterado por Joelson
        //evt.grupo = 2;
        let varGrupo2: Number = 2;
        evt.grupo.push(varGrupo2);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 1;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        //alterado por Joelson
        //evt.mensagemParaProtocolo = "Mensagem para protocolo";

        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'Connect_Direct';

        // Dados Origem
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.instalacaoRetorno.codigo;
        origem.vrsInstalacaoProdutoOrigem = this.instalacaoRetorno.versao;
        origem.clienteOrigem = this.clienteRetorno;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        let destino: DestinoTransmissao = new DestinoTransmissao();

        if (this.canalTransmissao.value == 'connect' && !this.temOperacao()) {
            // Dados Destino - BB.DSPERIMETRO
            destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoConnectPerimetro;
            destino.vrsInstalacaoProdutoDestino = 1;

            let clientePerimetro = new Cliente();
            clientePerimetro.codTipoCliente = 1;
            clientePerimetro.userAplicacao = new UserAplicacao();
            clientePerimetro.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClientePerimetro;
            clientePerimetro.userAplicacao.versaoUserAplicacao = 1;
            destino.clienteDestino = clientePerimetro;
        } else {
            // Dados Destino - BB.DSGMT
            destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoConnectGMT;
            destino.vrsInstalacaoProdutoDestino = 1;

            let clienteB2B = new Cliente();
            clienteB2B.codTipoCliente = 1;
            clienteB2B.userAplicacao = new UserAplicacao();
            clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
            clienteB2B.userAplicacao.versaoUserAplicacao = 1;
            destino.clienteDestino = clienteB2B;
        }

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemRegex',
            this.nomeArqToRegex(this.fluxoForm.value.arqOrigemRetorno)));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino', '/dados/recebidos/&ArquivoOrigem.'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_origem', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_destino', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', 'NEW'));

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        this.numEtapa++;
        return evt;
    }

    // Segundo evento do arquivo de Retorno
    eventoRetorno2(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEtapa;

        // alterado por Joelson
        // evt.grupo = 2;

        let varGrupo2: Number = 2;
        evt.grupo.push(varGrupo2);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 4;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        //alterado por Joelson
        // evt.mensagemParaProtocolo = "Mensagem para protocolo";
        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        evt.dependencia = new Array<Dependencia>();
        let dep = new Dependencia();
        dep.eventoAnterior = this.numEvento - 1;
        dep.codRetornoMin = 0;
        dep.codRetornoMax = 0;

        //alterado por Joelson
        //dep.qtdSegundosMaxEntreEventos = 0;
        evt.qtdSegundosMaxEntreEventos = 0;


        evt.dependencia.push(dep);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        let origem: OrigemTransmissao = new OrigemTransmissao();
        let destino: DestinoTransmissao = new DestinoTransmissao();
        eventoTransmissao.parmTransmissao = new Array<Parametro>();

        let clienteB2B = new Cliente();
        clienteB2B.codTipoCliente = 1;
        clienteB2B.userAplicacao = new UserAplicacao();
        clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
        clienteB2B.userAplicacao.versaoUserAplicacao = 1;

        origem.clienteOrigem = clienteB2B;

        switch (this.canalTransmissao.value) {
            case 'connect':
                eventoTransmissao.nomeItemConfiguracaoProduto = 'Connect_Direct';
                if (!this.temOperacaoRetorno()) {

                    let clientePerimetro = new Cliente();
                    clientePerimetro.codTipoCliente = 1;
                    clientePerimetro.userAplicacao = new UserAplicacao();
                    clientePerimetro.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClientePerimetro;
                    clientePerimetro.userAplicacao.versaoUserAplicacao = 1;

                    // Dados Origem - BB.DSPERIMETRO
                    origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoConnectPerimetro;
                    origem.vrsInstalacaoProdutoOrigem = 1;
                    origem.clienteOrigem = clientePerimetro;

                } else {
                    // Dados Origem - BB.DSGMT
                    origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoConnectGMT;
                    origem.vrsInstalacaoProdutoOrigem = 1;
                }

                eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino',
                    this.preparaVariaveisNomeArquivo(this.fluxoForm.value.arqDestinoRetorno)));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', this.fluxoForm.value.arqExistente));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_origem', this.fluxoForm.value.tpArqOrigem));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_destino', this.fluxoForm.value.tpArqOrigem));

                break;

            case 'rvs':
                eventoTransmissao.nomeItemConfiguracaoProduto = 'Odette';

                // Dados Origem - BBODETTEBORDA
                origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoOdette;
                origem.vrsInstalacaoProdutoOrigem = 1;

                eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino',
                    this.preparaVariaveisNomeArquivo(this.fluxoForm.value.arqDestinoRetorno)));
                break;

            case 'xfb':
                eventoTransmissao.nomeItemConfiguracaoProduto = 'PESIT';

                // Dados Origem - BBPESITBORDA
                origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoPESIT;
                origem.vrsInstalacaoProdutoOrigem = 1;

                eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino',
                    this.preparaVariaveisNomeArquivo(this.fluxoForm.value.arqDestinoRetorno)));
                break;

            case 'web':
                eventoTransmissao.nomeItemConfiguracaoProduto = 'SIA';

                // Dados Origem - SIA PADRÃO
                origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoSIAPadrao;
                origem.vrsInstalacaoProdutoOrigem = this.instalacaoRetorno.versao;

                eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemB2B', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino', '&ArquivoOrigem.'));
                break;
        }

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        destino.codInstalacaoProdutoDestino = this.instalacaoOrigem.codigo;
        destino.vrsInstalacaoProdutoDestino = this.instalacaoOrigem.versao;
        destino.clienteDestino = this.clienteOrigem;

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        this.numEtapa++;
        return evt;
    }

    salvarFluxo() {

        /* TODO - Têm que sair daqui e ficar lá embaixo */
        /* this.verificarCliente();
        this.verificarInstalacaoProduto(); */

        this.numRunTask = 1;
        this.numEvento = 1;
        this.numEtapa = 1;

        this.ftaService.novoFluxo();
        if (this.ftaService.fta.eventos == null) {
            this.ftaService.fta.eventos = new Array<Evento>();
        }

        // Dados FTA
        this.ftaService.fta.fta = 0;
        this.ftaService.fta.versao = 0;
        this.ftaService.fta.nome = this.fluxoForm.value.nome;
        this.ftaService.fta.descricao = this.fluxoForm.value.descricao;
        this.ftaService.fta.subfluxoVigente = 1;

        // Dados Subfluxo
        this.ftaService.fta.subfluxoPossiveis = new Array<SubfluxoPossivel>();
        let subfluxoPossivel = new SubfluxoPossivel();
        subfluxoPossivel.nrSubfluxo = 1;
        subfluxoPossivel.descricaoSubfluxo = 'Fluxo principal';
        this.ftaService.fta.subfluxoPossiveis.push(subfluxoPossivel);

        // Criar eventos de transmissão de acordo com ORIGEM/DESTINO:
        // SIA
        if (this.canalTransmissao.value == 'web') {
            this.ftaService.fta.eventos.push(this.transmissaoSIA1());
            if (this.tipoDestino.value != 'web' || this.temOperacao()) {
                this.ftaService.fta.eventos.push(this.transmissaoSIA2());
            }

            // Connect Direct
        } else if (this.canalTransmissao.value == 'connect') {
            this.ftaService.fta.eventos.push(this.transmissaoConnect1());
            this.ftaService.fta.eventos.push(this.transmissaoConnect2());
            if (!this.temOperacao() && this.tipoDestino.value == 'web') {
                this.ftaService.fta.eventos.push(this.eventoFinalWeb());
            }

            // ODETTE/RVS ou PESIT/XFB
        } else if (this.canalTransmissao.value == 'rvs' || this.canalTransmissao.value == 'xfb') {
            this.ftaService.fta.eventos.push(this.transmissaoOdettePesit1());
            if (!this.temOperacao()) {
                this.ftaService.fta.eventos.push(this.transmissaoOdettePesit2());
            }
        }

        // Das operações em diante, não importa a origem: o evento final será o mesmo (web ou BB)
        if (this.temOperacao()) {
            this.eventosOperacao().forEach(element => {
                this.ftaService.fta.eventos.push(element);
            });
            if (this.tipoDestino.value == 'web') {
                this.ftaService.fta.eventos.push(this.eventoFinalWeb());
            } else {
                this.ftaService.fta.eventos.push(this.eventoFinalBB());
            }
        }

        // Eventos de retorno
        if (this.temRetorno()) {
            this.numEtapa = 1;

            this.ftaService.fta.eventos.push(this.eventoRetorno1());
            if (this.temOperacaoRetorno()) {
                this.eventosOperacaoRetorno().forEach(element => {
                    this.ftaService.fta.eventos.push(element);
                });
            }
            this.ftaService.fta.eventos.push(this.eventoRetorno2());
        }

        this.resumoFta();

    }

    // Monta objeto de resumo para confirmação dos dados inseridos antes de salvar o FTA
    resumoFta() {

        // Origem
        this.ftaService.resumoFTA.arqOrigem = this.fluxoForm.value.arqOrigem;
        this.ftaService.resumoFTA.tipoOrigem = this.canalTransmissao.value;
        this.ftaService.resumoFTA.ambienteMFOrigem = this.fluxoForm.value.ambienteMFOrigem;
        this.ftaService.resumoFTA.hostnameOrigem = this.hostnameOrigem.value;
        this.ftaService.resumoFTA.uorOrigem = this.uorOrigem.value;
        this.ftaService.resumoFTA.tpArqOrigem = this.fluxoForm.value.tpArqOrigem;

        // Operações
        this.ftaService.resumoFTA.descompactar = '';
        this.ftaService.resumoFTA.layout = '';
        this.ftaService.resumoFTA.compactar = '';
        this.ftaService.resumoFTA.inserirHeader = '';
        this.ftaService.resumoFTA.inserirTrailer = '';

        if (this.descompactar.value == true) {
            this.ftaService.resumoFTA.descompactar = this.tipoArqCompactado.value;
        }
        if (this.layout.value == true) {
            let mapa = this.novoMapa;
            if (mapa == '') {
                mapa = $('select[id=mapaConversao]').val();
            }
            this.ftaService.resumoFTA.layout = mapa;
        }
        if (this.compactar.value == true) {
            this.ftaService.resumoFTA.compactar = this.tipoArqCompactado2.value;
        }
        if (this.inserirHeader.value == true) {
            this.ftaService.resumoFTA.inserirHeader = this.conteudoHeader.value;
            this.ftaService.resumoFTA.inserirTrailer = this.conteudoTrailer.value;
        }

        // Destino
        this.ftaService.resumoFTA.tipoDestino = this.fluxoForm.value.tipoDestino;
        this.ftaService.resumoFTA.arqDestino = this.fluxoForm.value.dirDestino + this.montaArqDestino;
        this.ftaService.resumoFTA.ambienteMFDestino = this.fluxoForm.value.ambienteMFDestino;
        this.ftaService.resumoFTA.hostnameDestino = this.hostnameDestino.value;
        this.ftaService.resumoFTA.uorDestino = this.uorDestino.value;
        this.ftaService.resumoFTA.arqExistente = this.fluxoForm.value.arqExistente;
        this.ftaService.resumoFTA.recfm = this.fluxoForm.value.recfm;
        this.ftaService.resumoFTA.lrecl = this.fluxoForm.value.lrecl;
        this.ftaService.resumoFTA.blksize = this.fluxoForm.value.blksize;
        this.ftaService.resumoFTA.rotinaDestino = this.fluxoForm.value.rotinaDestino;

        // Retorno
        if (this.temOperacaoRetorno()) {
            this.ftaService.resumoFTA.ambienteMFRetorno = this.ambienteMFRetorno.value;
            this.ftaService.resumoFTA.arqDestinoRetorno = this.montaArqDestinoRetorno;
            this.ftaService.resumoFTA.arqOrigemRetorno = this.fluxoForm.value.arqOrigemRetorno;
            if (this.descompactarR.value == true) {
                this.ftaService.resumoFTA.descompactarR = this.tipoArqCompactadoR.value;
            }
            if (this.layoutR.value == true) {
                let mapa = this.novoMapaR;
                if (mapa == '') {
                    mapa = $('select[id=mapaConversaoR]').val();
                }
                this.ftaService.resumoFTA.layoutR = mapa;
            }
            if (this.compactarR.value == true) {
                this.ftaService.resumoFTA.compactarR = this.tipoArqCompactadoR2.value;
            }
            if (this.inserirHeaderR.value == true) {
                this.ftaService.resumoFTA.inserirHeaderR = this.conteudoHeaderR.value;
                this.ftaService.resumoFTA.inserirTrailerR = this.conteudoTrailerR.value;
            }
        }

        // Abrir página modal com o Resumo do FTA
        this.modalService.abrirPaginaModal('resumo-fta-modal', {}, {},
            '<div class=\'text-center titulo\'>Resumo - Fluxo de Transmissão de Arquivos</div><hr class=\'decoracao-titulo\' />', 'Fechar')
            .subscribe(resp => {

                // Após confirmação do usuário, salvar FTA
                if (resp == 'confirmar') {

                    this.globalService.loading = true;

                    // TODO - Esses três têm que ser síncronos!!!!
                    this.verificarCliente();
                    this.verificarInstalacaoProduto();
                    this.catalogoApi.criaEditaFta(0, 0, this.ftaService.fta)
                        .subscribe(
                            resposta => {
                                this.ftaService.msgFtaSalvo = 'sucesso';
                                this.ftaService.numFtaSalvo = resposta.codigoCriado;
                                this.globalService.loading = false;
                                this.router.navigate(['/home']);
                                return false;
                            },
                            erro => {
                                this.ftaService.msgFtaSalvo = 'erro';
                                this.globalService.loading = false;
                                this.router.navigate(['/home']);
                                return false;
                            }
                        );
                }
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/fluxo-cliente-externo/fluxo-cliente-externo.ts